import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconText2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-2"><path d="M3.75 3.75H12H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 20.25V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconText2;
